import { Routes, Route } from 'react-router-dom'
import { Box } from '@mui/material'

import Layout from '@/components/Layout/Layout'
import Dashboard from '@/pages/Dashboard'
import OrderList from '@/pages/Orders/OrderList'
import OrderForm from '@/pages/Orders/OrderForm'
import ShipperList from '@/pages/Shippers/ShipperList'
import ShipperForm from '@/pages/Shippers/ShipperForm'
import ConsigneeList from '@/pages/Consignees/ConsigneeList'
import ConsigneeForm from '@/pages/Consignees/ConsigneeForm'
import ProductList from '@/pages/Products/ProductList'
import StoreList from '@/pages/Stores/StoreList'

// 顧客（エンドユーザー）向けページ
import { CustomerAuthProvider } from '@/context/CustomerAuthContext'
import LoginPage from '@/pages/Customer/LoginPage'
import CheckoutPage from '@/pages/Customer/CheckoutPage'
import CheckoutCompletePage from '@/pages/Customer/CheckoutCompletePage'
import CustomerOrderHistoryPage from '@/pages/Customer/CustomerOrderHistoryPage'
import AddressBookPage from '@/pages/Customer/AddressBookPage'
import TokushohonPage from '@/pages/Customer/Legal/TokushohonPage'
import TermsPage from '@/pages/Customer/Legal/TermsPage'

function App() {
  return (
    <CustomerAuthProvider>
      <Routes>
        {/* 顧客ポータル向けルート（独立したCustomerLayoutを使用） */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/checkout/complete" element={<CheckoutCompletePage />} />
        <Route path="/mypage/orders" element={<CustomerOrderHistoryPage />} />
        <Route path="/mypage/addresses" element={<AddressBookPage />} />
        <Route path="/tokushohon" element={<TokushohonPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<TermsPage />} />

        {/* 管理者用ルート（サイドバー付きAdmin Layoutを使用） */}
        <Route
          path="/*"
          element={
            <Box sx={{ display: 'flex', minHeight: '100vh', width: '100%' }}>
              <Layout>
                <Routes>
                  <Route path="/" element={<Dashboard />} />

                  {/* 注文管理 */}
                  <Route path="/orders" element={<OrderList />} />
                  <Route path="/orders/new" element={<OrderForm />} />
                  <Route path="/orders/:id/edit" element={<OrderForm />} />

                  {/* 荷主管理 */}
                  <Route path="/shippers" element={<ShipperList />} />
                  <Route path="/shippers/new" element={<ShipperForm />} />
                  <Route path="/shippers/:id/edit" element={<ShipperForm />} />

                  {/* 送付先管理 */}
                  <Route path="/consignees" element={<ConsigneeList />} />
                  <Route path="/consignees/new" element={<ConsigneeForm />} />
                  <Route path="/consignees/:id/edit" element={<ConsigneeForm />} />

                  {/* 商品管理 */}
                  <Route path="/products" element={<ProductList />} />

                  {/* 集配所管理 */}
                  <Route path="/stores" element={<StoreList />} />
                </Routes>
              </Layout>
            </Box>
          }
        />
      </Routes>
    </CustomerAuthProvider>
  )
}

export default App